import { apiClient } from '@/services/api'

const state = () => ({
    enquetesProducao: null,
    enqueteEmExibicao: null,
    flg_favorita: false,
    filtroEnquetes: localStorage.getItem('@socialcam/filtro_texto_enquetes') || null,
    categorias: null,
    portaisCategorias: null,
    portais: null,
    selectedPortal: null,
    selectedCategoria: null
})

const getters = {
    getterEnquetesProducao: state => {
        return state.enquetesProducao
    },
    getterEnqueteEmExibicao: state => {
        return state.enqueteEmExibicao
    },
    getterFiltroEnquetes: state => {
        return state.filtroEnquetes
    },
    getterCategoriasEnquetes: state => {
        return state.categorias
    },
    getterPortaisCategorias: state => {
        return state.portaisCategorias
    },
    getterPortaisEnquetes: state => {
        return state.portais
    },
    getterSelectedPortal: state => {
        return state.selectedPortal
    },
    getterSelectedCategoria: state => {
        return state.selectedCategoria
    }
}

const actions = {
    async getEnquetesProducao({ commit }, payload) {
        const { cod_producao, filtro_texto, page, size, cod_portal, id_categoria } = payload

        if (!cod_portal) return

        const params = {
            cod_producao: cod_producao ?? '',
            filtro_texto: filtro_texto || '',
            page        : page || '1',
            size        : size || '10',
            id_portal   : cod_portal,
            id_categoria: id_categoria ?? ''
        }

        Object.keys(params).forEach(k => {
            if (params[k] === null || (k === 'id_portal' && params[k] === '')) {
                delete params[k]
            }
        })

        const queryString = new URLSearchParams(params).toString()
        const url = `enquetes/?${queryString}`

        try {
            const { data } = await apiClient.get(url)
            commit('setEnquetesProducao', data.enquetes)
        } catch (error) {
            console.error(error)
        }
    },

    async getEnqueteEmExibicao ({ commit }, { cod_producao }) {
        try {
            const { data } = await apiClient.get(`enquetes/exibicao/${cod_producao}`)
            commit('setEnqueteEmExibicao', data)
        } catch (error) {
            console.error('Error in getEnqueteEmExibicao:', error)
        }
    },

    async updateEnqueteQrCodeFlag(context, { cod_producao, qr_code, qr_code_combined, tarja_mode }) {
        try {
            const payload = { qr_code };

            if (qr_code_combined !== undefined) {
                payload.qr_code_combined = qr_code_combined;
            }

            if (tarja_mode !== undefined) {
                payload.tarja_mode = tarja_mode;
            }

            const response = await apiClient.patch(`producao/${cod_producao}/flg-enquete-qr-code`, payload)
            return response.data
        } catch (error) {
            console.error('Error updating QR Code flag:', error)
            throw error
        }
    },

    async getCategoriasEnquetes ({ commit }, payload ) {
        try {
            const { page, size } = payload;
            const { data } = await apiClient.get(`enquetes/categorias?page=${page}&size=${size}`)
            commit('setCategoriasEnquetes', data)
        } catch (error) {
            console.error(error)
        }
    },

    async getPortaisEnquetes ({ commit }) {
        try {
            const { data } = await apiClient.get('enquetes/portais')
            commit('setPortaisEnquetes', data)
            return data
        } catch (error) {
            console.error(error)
            return []
        }
    },

    async getCategoriasPorPortal ({ commit }, { id_portal }) {
        try {
            const { data } = await apiClient.get(`enquetes/portais/${id_portal}/categorias`)
            commit('setPortaisCategorias', data)
        } catch (error) {
            console.error(error)
        }
    },

    setFlgFavorita ({ commit }, value) {
        try {
            commit('setFlgFavorita', value)
        } catch (error) {
            console.error(error)
        }
    },

    setFiltroEnquetes ({ commit }, value) {
        try {
            commit('setFiltroEnquetes', value)
        } catch (error) {
            console.error(error)
        }
    },

    setSelectedPortal ({ commit }, value) {
        try {
            commit('setSelectedPortal', value)
        } catch (error) {
            console.error(error)
        }
    },

    setSelectedCategoria ({ commit }, value) {
        try {
            commit('setSelectedCategoria', value)
        } catch (error) {
            console.error(error)
        }
    }
}

const mutations = {
    setEnquetesProducao(state, value) {
        state.enquetesProducao = value
    },
    setEnqueteEmExibicao(state, value) {
        state.enqueteEmExibicao = value
    },
    setFlgFavorita(state, value) {
        state.flg_favorita = value
    },
    setFiltroEnquetes(state, value) {
        state.filtroEnquetes = value
    },
    setCategoriasEnquetes(state, value) {
        state.categorias = value;
    },
    setPortaisEnquetes(state, value) {
        state.portais = value;
    },
    setPortaisCategorias(state, value) {
        state.portaisCategorias = value;
    },
    setSelectedPortal(state, value) {
        state.selectedPortal = value;
    },
    setSelectedCategoria(state, value) {
        state.selectedCategoria = value
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}